var UpdateStateSerialiser = require('services/topic-update/update-source-state-serialiser');
var CIDSerialiser = require('conversation/conversation-id-serialiser');

module.exports = {
    read : function(input) {
        var cid = CIDSerialiser.read(input);
        var old = UpdateStateSerialiser.read(input);
        var current = UpdateStateSerialiser.read(input);

        return {
            cid : cid,
            old : old,
            current : current
        };
    },
    write : function(output, req) {
        CIDSerialiser.write(output, req.cid);
        UpdateStateSerialiser.write(output, req.old);
        UpdateStateSerialiser.write(output, req.current);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-state-request-serialiser.js
// module id = 1707
// module chunks = 1